<template>
  <div class="header-box">
    <div class="header-left">
      <div class="logo clearfix">
        <div class="fl"
             v-if="showMojing">
          <img src="../assets/logo_ld.png"
               class="logo-ld">
        </div>
        <div class="fl"
             v-if="showMojing">
          <div class="logoTitle"
               :style="language=='zh'?'':'font-weight:normal'">{{$t('topHead.logo_title')}}</div>
          <div class="logoText">MKTINDEX.COM</div>
        </div>
        <div class="fl">
          <el-popover placement="bottom-start"
                      trigger="hover"
                      v-if="showMojing && language == 'zh'">
            <div>
              <img src="../assets/kf.png">
            </div>
            <div style="text-align:center;">扫码联系售后人员</div>
            <span slot="reference">
              <img src="../assets/kf1.png"
                   class="kf"><span class="text">售后支持</span>
            </span>
          </el-popover>
          <div class="inspiration-text"
               v-if="showMojing || mktShowInspiration"
               @click="jumpToInspiration">
            <img src="../assets/dp1.png"
                 class="dp">
            <span class="icon-text-dp">{{ inspiration }}</span>
          </div>
          <div class="usage-scenario"
               v-if="showMojing">
            <img src="../assets/notebook1.png"
                 class="notebook">
            <a href="https://qmctsz2s8t.feishu.cn/docx/Vx2Udr2JBoDF1Gxb2Wcc3hAOnAd"
              target="_blank"
              class="scenario">{{$t('topHead.user_cases')}}</a>
          </div>
        </div>
      </div>
    </div>
    <div class="header-right">
      <div class="language">
        <span @click="changeLanguage('zh')"
              :class="{'selected': language=='zh'}">{{$t('topHead.Chinese')}}</span>
        <el-divider direction="vertical"></el-divider>
        <span @click="changeLanguage('en')"
              :class="{'selected': language=='en'}">{{$t('topHead.English')}}</span>
      </div>
      <div class="user">
        <userinfo @userLogin="userLoginValue"
                  :getUserInfo="getUserInfo"
                  :getPhone="getPhone">
        </userinfo>
      </div>
    </div>
  </div>
</template>

<script>
import { userinfo } from 'common'
import { getUserInfo } from '@/api/user'
import { getPhone } from '@/api/public'
export default {
  components: {
    userinfo,
  },
  data() {
    return {
      loginInfo: {},
      getUserInfo,
      getPhone,
      showMojing: false,
      mktShowInspiration: false,
    }
  },
  props: {
    showInspiration: {
      default: false,
      type: Boolean,
    }
  },
  computed: {
    inspiration() {
      if (!this.showInspiration) {
        if (this.language == 'zh') {
          return '灵感中心'
        } else {
          return 'Inspiration Center'
        }
      } else {
        if (this.language == 'zh') {
          return '返回CMI平台'
        } else {
          return 'Return to CMI platform'
        }
      }
    },
    language() {
      return localStorage.getItem('language')
    },
  },
  methods: {
    userLoginValue(val) {
      this.loginInfo = val
      this.$store.dispatch('user/changeLoginInfo', val)
    },
    jumpToInspiration() {
      this.$emit('inspiration')
    },
    changeLanguage(lan) {
      localStorage.setItem('language', lan)
      location.reload()
    },
  },
  watch: {
    '$store.state.user.loginInfo.is_partner': {
      handler(newVal, oldVal) {
        if (newVal) {
          if (location.host.includes('mktindex.com')) {
            this.mktShowInspiration = true
          } else {
            this.mktShowInspiration = false
            // 是OEM用户的同时，ins不存在或者等于false
            if (!this.$route.query.showInspiration || this.$route.query.showInspiration == 'false') {
              this.jumpToInspiration()
            }
          }
          this.showMojing = false
        } else {
          this.showMojing = true
        }
      }
    },
  },
}
</script>

<style scoped lang='less'>
.header-left {
  color: #fff;
  .lb {
    display: inline-block;
  }
  .logo {
    .logo-ld {
      height: 35px;
      margin-top: 10px;
      margin-right: 12px;
    }
    .fl {
      float: left;
    }
    .fr {
      float: right;
    }
    .logoTitle {
      font-size: 16px;
      font-weight: bold;
      color: #fff;
      margin-top: 14px;
      line-height: 20px;
      text-align: center;
    }
    .logoText {
      font-size: 12px;
      color: #fff;
      transform: scale(0.7);
      text-align: center;
      line-height: 10px;
    }
  }
  .kf {
    vertical-align: -3px;
    cursor: pointer;
    width: 16px;
    margin-left: 30px;
  }
  .text {
    font-style: normal;
    font-size: 14px;
    margin-left: 6px;
  }
  .inspiration-text {
    cursor: pointer;
    display: inline-block;
    line-height: 60px;
    height: 60px;
    margin-left: 20px;
    .dp {
      vertical-align: -2px;
      width: 16px;
      height: 16px;
      margin-right: 6px;
    }
    .icon-text-dp {
      font-size: 14px;
      font-weight: 400;
    }
  }
  .usage-scenario {
    display: inline-block;
    margin-left: 20px;
    .notebook {
      vertical-align: -3px;
      width: 16px;
      height: 16px;
      margin-right: 6px;
    }
    .scenario {
      display: inline-block;
      line-height: 16px;
      font-size: 14px;
      color: #ffffff;
      padding-top: 22px;
    }
    .scenario:hover,
    .scenario:focus {
      text-decoration: unset;
    }
  }
}
.header-right {
  font-size: 14px;
  color: #fff;
  .language {
    display: inline-block;
    line-height: 60px;
    height: 60px;
    span {
      cursor: pointer;
      opacity: 0.5;
      &.selected {
        opacity: 1;
      }
    }
  }
  .user {
    display: inline-block;
    line-height: 60px;
    height: 60px;
    margin-left: 20px;
  }
  .el-dropdown-link {
    color: #fff;
  }
}
.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
}
</style>
